import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import jwtDecode from 'jwt-decode';
import supportsLocalStorage from './supportsLocalStorage';
import { setSeismicAuthService } from './seismicBrowserService';

export const isAuthTokenValid = authToken => {
  if (!authToken) {
    return false;
  }
  try {
    const { exp } = jwtDecode(authToken);
    const now = new Date();
    const tokenExp = new Date(exp * 1000);

    if (now > tokenExp) {
      throw new Error('Auth token has expired');
    }
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};

export const removeAuthTokenFromLocalStorage = () => {
  const AUTHTOKEN = 'seismicAuthToken';
  if (supportsLocalStorage && localStorage.getItem(AUTHTOKEN)) {
    localStorage.removeItem(AUTHTOKEN);
  }
};

export const getSeismicAuthToken = async () => {
  const isLocalStorageSupported = supportsLocalStorage;
  const storedAuthToken =
    isLocalStorageSupported && localStorage.getItem('seismicAuthToken');

  if (isAuthTokenValid(storedAuthToken)) {
    setSeismicAuthService(storedAuthToken);
    return storedAuthToken;
  }

  try {
    const { token } = await request.get(routes.SEISMIC.AUTH_TOKEN);
    if (!token && !isAuthTokenValid(token)) {
      throw new Error('Seismic auth token is invalid');
    }
    if (isLocalStorageSupported) {
      localStorage.setItem('seismicAuthToken', token);
    }
    setSeismicAuthService(token);
    return token;
  } catch (error) {
    console.error(error);
    removeAuthTokenFromLocalStorage();
    return '';
  }
};

export const replaceCAToken = async accessToken => {
  if (accessToken === null || accessToken.trim() === '') {
    return 'accessToken is required';
  }

  try {
    await request.get('/content', { seismicToken: accessToken, replace: 1 });
    setSeismicAuthService(accessToken);
    if (supportsLocalStorage) {
      localStorage.setItem('seismicAuthToken', accessToken);
    }
    return 'success';
  } catch {
    return 'failed';
  }
};
